export default __webpack_public_path__ + "static/media/hvac-main-category.4c4ac6c0.jpeg";